import { defineSlotRecipe } from "@chakra-ui/react";
export const fieldRecipe = defineSlotRecipe({
    className: "chakra-field",
    slots: ["root", "label", "helperText", "errorText"],
    base: {
        label: {
            display: "block",
            textAlign: "start",
            fontSize: "13px",
            fontWeight: "normal",
            fontFamily: "heading",
            color: "fg.default",
            marginBottom: "1",
        },
        helperText: {
            color: "fg.muted",
            lineHeight: "1.2",
            fontSize: "sm",
        },
        errorText: {
            display: "flex",
            alignItems: "center",
            gap: "2",
            color: "fg.error",
            lineHeight: "1.2",
            fontSize: "sm",
        },
    },
    variants: {
        size: {
            sm: {
                label: {
                    fontSize: "xs",
                },
                helperText: {
                    fontSize: "xs",
                },
                errorText: {
                    fontSize: "xs",
                },
            },
            md: {
                label: {
                    fontSize: "13px",
                },
                helperText: {
                    fontSize: "sm",
                },
                errorText: {
                    fontSize: "sm",
                },
            },
            lg: {
                label: {
                    fontSize: "md",
                },
                helperText: {
                    fontSize: "sm",
                },
                errorText: {
                    fontSize: "sm",
                },
            },
        },
    },
    defaultVariants: {
        size: "md",
    },
});
